
export default {
    name: 'OcRadio',

    props: {
        initialValue: {
            type: [String, Boolean],
            default: '',
        },
        value: {
            type: [String, Number],
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        forId: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        isMultiline: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            radioboxStatus: this.initialValue ? this.value : false,
        }
    },

    watch: {
        initialValue: function (val) {
            this.radioboxStatus = val
        },
    },

    methods: {
        handleChange() {
            const payload = {
                value: this.radioboxStatus,
            }
            if (this.forId) {
                payload.id = this.forId
            }
            this.$emit('radiobox-updated', payload)
        },
    },
}
